import React from 'react';
import { Tooltip } from 'antd';
import styles from './Dock.module.css';

/** One 40px dock button; `active` fills it with the brand blue. */
const DockButton = ({ title, active = false, onClick, children }) => (
    <Tooltip title={title} placement="right">
        <button
            type="button"
            className={`${styles.button} ${active ? styles.buttonActive : ''}`}
            onClick={onClick}
            aria-label={title}
            aria-pressed={active}
        >
            {children}
        </button>
    </Tooltip>
);

export default DockButton;
